export default "__VITE_ASSET__Bf5GHLvb__"